import * as materials from './materials.selectors';

export default {
 materials,
};
